import { formatDistanceToNowStrict, format } from 'date-fns'

// // ----------------------------------------------------------------------

// export function fDate(date) {
//   return format(new Date(date), 'dd MMMM yyyy');
// }

// export function fDateTime(date) {
//   return format(new Date(date), 'dd MMM yyyy HH:mm');
// }

// export function fDateTimeSuffix(date) {
//   return format(new Date(date), 'dd/MM/yyyy hh:mm p');
// }

export function fToNow(date: string | number | Date) {
  const postDate = new Date(date) // Assuming post.date contains the date string
  const isRecent = new Date().getTime() - postDate.getTime() < 7 * 24 * 60 * 60 * 1000 // Check if within one week
  const formattedDate = isRecent
    ? `${formatDistanceToNowStrict(postDate, { addSuffix: true })}`
    : `${format(postDate, 'MMM dd, yyyy')}`
  return formattedDate
}
